import { useQuery } from '@tanstack/react-query';
import { FALLBACK_ORTHO_LAYERS, fetchNationalOrthoLayers, type OrthoLayer } from './imagery';

const ONE_HOUR = 60 * 60 * 1000;

/**
 * The national orthophoto surveys currently published on geodata.gov.md,
 * newest first. Falls back to the known 2020/2021 surveys while loading or
 * when the server cannot be reached, so the layer always draws something.
 */
export function useNationalOrthoLayers(): OrthoLayer[] {
  const { data } = useQuery({
    queryKey: ['national-ortho-layers'],
    queryFn: ({ signal }) => fetchNationalOrthoLayers(signal),
    staleTime: ONE_HOUR,
    retry: 1,
    refetchOnWindowFocus: false,
  });
  return data ?? FALLBACK_ORTHO_LAYERS;
}
